"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var InlineOnboarding_1 = __importDefault(require("InlineOnboarding/InlineOnboarding"));
var PipelineReportOnboarding = function () {
    return (react_1.default.createElement(InlineOnboarding_1.default, { title: "Pipeline report is live!", description: "Use Sales velocity to increase your team\u2019s performance", video: {
            videoThumbnail: "pipeline-report-onboarding-video-thumb.png",
            videoSrc: "https://stock-videos.qwilr.com/onboarding/sales-velocity-video-outline.mp4",
        }, promptId: PromptTypes_1.PromptId.PipelineReportOnboarding, enabled: true }));
};
exports.default = PipelineReportOnboarding;
